import { render } from "./splide-arrows.vue?vue&type=template&id=79625a86"
import script from "./splide-arrows.vue?vue&type=script&lang=js"
export * from "./splide-arrows.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__